module.exports = __webpack_public_path__ + "img/takatihohall.7dafd887.jpg";